import React from 'react'
import Footer from '../footer/footer'
import StudyGer from './StudyGer'

function StudyAtUK() {
  return (
    <div>
    <StudyGer
    title="Ukrain"/>
    <Footer/>
    </div>
  )
}

export default StudyAtUK